// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__22h0L","location":"Header_location__3uCDr"};